/**
 * Created by Administrador on 24/10/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('customerCorporateReportService',customerCorporateReportService);

    customerCorporateReportService.$inject = ['$http', 'CONFIG','messageService'];

    function customerCorporateReportService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '';

        var service = {
            getCustomerCorporateOperations: getCustomerCorporateOperations,
            getCustomerCorporateOperationsPdf: getCustomerCorporateOperationsPdf,
            getCustomerCorporateOwnOperations: getCustomerCorporateOwnOperations,
            getCustomerCorporateOwnOperationsPdf: getCustomerCorporateOwnOperationsPdf,
            getCustomerCorporateReportKardex: getCustomerCorporateReportKardex
        };

        return service;

        function getCustomerCorporateOperations(data){
            var params = '/cargoReport/corporateClient?corporateParentId='+data.corporateParentId+'&fromDate='+data.fromDate +
                '&toDate=' + data.toDate;
            return $http.get(urlBase + params)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getCustomerCorporateOperationsPdf(data){
            return $http.get(urlBase +'/cargoReport/corporateClient/pdf?corporateParentId='+data.corporateParentId+'&fromDate='+data.fromDate +
                '&toDate=' + data.toDate,
                {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getCustomerCorporateOwnOperations(data){
            return $http.get(urlBase + '/cargoReport/ownCorporateClient?fromDate='+data.fromDate + '&toDate=' + data.toDate)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getCustomerCorporateOwnOperationsPdf(data){
            return $http.get(urlBase + '/cargoReport/ownCorporateClient/pdf?fromDate='+data.fromDate + '&toDate=' + data.toDate, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.registerError('');
                });
        }

        function getCustomerCorporateReportKardex(data){
            return $http.get(urlBase + '/kardex/corporate/'+data.customerCorporateId+'?fromDate='+data.fromDate + '&toDate=' + data.toDate + '&customerCorporateName='+ data.customerCorporateName)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
